import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap"; // Import Bootstrap Button

const TermsAndConditions = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/login"); // Redirect to the login screen
    };

    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">
                    {/* Back Button at the Top */}
                    <div className="text-start mb-4">
                        <Button variant="secondary" onClick={handleBack}>
                            &larr; Back to Login
                        </Button>
                    </div>

                    <h1 className="card-title text-center mb-4">Terms and Conditions for {process.env.REACT_APP_NAME}</h1>
                    <p className="text-muted text-center">Effective Date: [2024-08-21]</p>

                    <p>
                        Welcome to <strong>{process.env.REACT_APP_NAME}</strong>! These terms and conditions outline the rules and regulations for the use of our Facebook app and TikTok app, <strong>{process.env.REACT_APP_NAME}</strong> ("the App"), which is developed and operated by {process.env.REACT_APP_NAME}.
                    </p>

                    <h2 className="mt-4">1. Acceptance of Terms</h2>
                    <p>
                        By accessing or using the App, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree with these Terms, you must not use the App.
                    </p>

                    <h2 className="mt-4">2. Use of the App</h2>
                    <p>
                        The App allows you to create posts on <strong>TikTok</strong>, and fetch all posts from your <strong>TikTok</strong> accounts. You agree to use the App only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use of the App.
                    </p>

                    <h2 className="mt-4">3. Account Information</h2>
                    <p>
                        To use the App, you may need to provide your <strong>TikTok</strong> account information. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                    </p>

                    <h2 className="mt-4">4. Intellectual Property</h2>
                    <p>
                        All content, trademarks, logos, and other intellectual property rights associated with the App are the property of {process.env.REACT_APP_NAME} or its licensors. You may not use, reproduce, or distribute any content from the App without our express permission.
                    </p>

                    <h2 className="mt-4">5. User-Generated Content</h2>
                    <p>
                        By creating or posting content through the App, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display your content as necessary to provide the services offered by the App.
                    </p>

                    <h2 className="mt-4">6. Privacy</h2>
                    <p>
                        Your use of the App is also governed by our <a href="/privacy-policy">Privacy Policy</a>, which outlines how we collect, use, and protect your personal information. By using the App, you consent to the practices described in our Privacy Policy.
                    </p>

                    <h2 className="mt-4">7. Limitation of Liability</h2>
                    <p>
                        The App is provided "as is" and "as available." We make no warranties or representations about the accuracy, completeness, or reliability of the App. To the fullest extent permitted by law, we disclaim all liability for any damages arising from your use of the App.
                    </p>

                    <h2 className="mt-4">8. Termination</h2>
                    <p>
                        We reserve the right to terminate or suspend your access to the App at any time, without notice, for any reason, including if we believe you have violated these Terms.
                    </p>

                    <h2 className="mt-4">9. Changes to the Terms</h2>
                    <p>
                        We may update these Terms from time to time. Any changes will be posted on this page, and we encourage you to review the Terms regularly. Your continued use of the App after any changes constitutes your acceptance of the new Terms.
                    </p>

                    <h2 className="mt-4">10. Governing Law</h2>
                    <p>
                        These Terms are governed by and construed in accordance with the laws of <strong>Texas, United States</strong>. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in <strong>Texas, United States</strong>.
                    </p>

                    <h2 className="mt-4">11. Contact Us</h2>
                    <p>
                        If you have any questions or concerns about these Terms, please contact us at:
                    </p>
                    <address>
                        <strong>Indie Author Academy LLC</strong><br />
                        657 Timberfalls Lane<br />
                        Henderson, NV 89015 US<br />
                        <a href="mailto:admin@indieauthormedia.com">admin@indieauthormedia.com</a>
                    </address>

                    <h2 className="mt-4">12. User Data Deletion</h2>
                    <p>
                        We do not store personal user details such as email addresses or phone numbers. The only data we store is related to users' posts, which we use exclusively for providing statistical insights and visualizations for users.
                    </p>
                    <p>
                        If you wish to delete your post-related data, please contact us at <a href="mailto:admin@indieauthormedia.com">admin@indieauthormedia.com</a>, and we will promptly remove your data from our systems. Please note that data deletion may affect the functionality of the App, including the ability to view past statistics and visualizations.
                    </p>

                    {/* Back Button at the Bottom */}
                    <div className="text-center mt-4">
                        <Button variant="secondary" onClick={handleBack}>
                            &larr; Back to Login
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;